import { render, staticRenderFns } from "./AvailableOtherLaboursNtar.vue?vue&type=template&id=2790922e&scoped=true"
import script from "./AvailableOtherLaboursNtar.vue?vue&type=script&lang=js"
export * from "./AvailableOtherLaboursNtar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2790922e",
  null
  
)

export default component.exports